import React from "react";
import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions , Platform ,Modal} from "react-native";
import Config from "../../Config";
import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, FontAwesome, Ionicons} from "@expo/vector-icons";
import AntDesign from "@expo/vector-icons/AntDesign";
import {Video} from 'expo-av';
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";
import Loading from "../Components/Loading";
import RenderHtml from "react-native-render-html";
import * as Linking from 'expo-linking';
import {useFocusEffect} from '@react-navigation/native';
import * as ScreenOrientation from 'expo-screen-orientation';
import SwitchToggle from "../Components/SwitchToggle";
import WordSplitter from "../Components/WordSplitter";

import Feather from '@expo/vector-icons/Feather';




// تعداد زیرنویس‌های قبل و بعد را اینجا تعیین می‌کنیم
const CONTEXT_COUNT = 3;

const Lesson = ({navigation, route}) => {
    const videoRef = React.useRef(null);
    const [isPreloading, setIsPreloading] = React.useState(false);
    let [disable, setDisable] = React.useState(false);
    let width = Dimensions.get("window").width;
    let [data, setData] = React.useState(false);

    const [subtitles, setSubtitles] = React.useState([]);
    const [currentSubtitle, setCurrentSubtitle] = React.useState('');

    // تغییر state ها به آرایه برای نگهداری چندین زیرنویس
    const [prevSubtitles, setPrevSubtitles] = React.useState([]);
    const [nextSubtitles, setNextSubtitles] = React.useState([]);

    // رفرنس برای جلوگیری از رندرهای اضافی و لگ شدن ویدیو
    const lastIndexRef = React.useRef(-1);

    const [showModal, setShowModal] = React.useState(false);
    const [showfarsi, setShowFarsi] = React.useState(true);
    const [showEnglish, setShowEnglish] = React.useState(true);

    const [isPlaying, setIsPlaying] = React.useState(false);


    const [category_id, setCategory_id] = React.useState(0);


    const [currentStartTime, setCurrentStartTime] = React.useState(0);

    const parseSRT = (srtContent) => {
        const lines = srtContent.split('\n');
        const subtitles = [];
        let current = {};
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i].trim();
            if (!line) {
                if (current.start !== undefined && current.end !== undefined && current.text) {
                    subtitles.push(current);
                    current = {};
                }
                continue;
            }
            if (!isNaN(line)) {
                current = {text: ''};
                continue;
            }
            if (line.includes('-->')) {
                const [startStr, endStr] = line.split('-->');
                current.start = timeToSeconds(startStr.trim());
                current.end = timeToSeconds(endStr.trim());
                continue;
            }
            current.text += (current.text ? '\n' : '') + line;
        }
        if (current.start !== undefined && current.end !== undefined && current.text) {
            subtitles.push(current);
        }
        return subtitles;
    };

    const timeToSeconds = (timeStr) => {
        const [hours, minutes, seconds] = timeStr.split(':');
        const [secs, ms] = seconds.split(',');
        return parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(secs) + (parseInt(ms || 0) / 1000);
    };

    useFocusEffect(
        React.useCallback(() => {
            async function changeScreenOrientation() {
                await ScreenOrientation.unlockAsync();
            }

            if (Platform.OS === "android") {
                changeScreenOrientation();
            }
            let timer = setTimeout(async () => {
                let token = await AsyncStorage.getItem('token');
                await axios.get(`${Config.api}/user/seenlesson/${route.params.lesson_id}`, {'headers': {Authorization: 'Bearer ' + token}});
            }, 10000);

            return () => {
                clearTimeout(timer);
                if (videoRef.current) {
                    videoRef.current.pauseAsync();
                    videoRef.current.unloadAsync();
                }
            };
        }, [])
    );

    React.useEffect(() => {
        getData();
    }, [route.params.lesson_id]);

    let getData = async () => {
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/lesson/${route.params.lesson_id}`, {'headers': {Authorization: 'Bearer ' + token}});
            if (res.data.code != 1) {
                Toast(res.data.error);
            }
            setData(res.data);

            if(res.data.category.length) {
                setCategory_id(res.data.category[0].id);
            }else{
                setCategory_id(0);
            }

            if (res.data.lesson.subtitle) {
                try {
                    const srtRes = await axios.get(`${Config.dl}/${res.data.lesson.subtitle}`);


                    const parsed = parseSRT(srtRes.data);
                    setSubtitles(parsed);
                } catch (err) {
                    console.log('Error loading SRT:', err);
                    Toast('خطا در بارگذاری زیرنویس');
                }
            }

        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }

    const nextlesson = async () => {
        try {
            setDisable(true);
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/nextlesson/${route.params.lesson_id}`, {'headers': {Authorization: 'Bearer ' + token}});
            setDisable(false);
            setShowModal(false);



            if (res.data.code != 1) {
                navigation.navigate('Course', {course_id: data.lesson.course_id});
            } else {
                navigation.push('Lesson', {lesson_id: res.data.nextlesson.lesson_id});
            }

        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }

    return (
        <View style={styles.container}>
            {data ?
                <>
                    <View style={styles.header}>
                        <TouchableOpacity style={{flex: 1}}>
                            <Text style={styles.title}>
                                {data.lesson.title}
                            </Text>
                        </TouchableOpacity>

                        <View style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginLeft : RFValue(15)
                        }}>
                            <Entypo name="eye" style={{marginLeft: 6}} size={18} color={Config.secondcolor}/>
                            <Text style={styles.h2}>{data.count_seen_user}</Text>
                        </View>
                        <TouchableOpacity onPress={() => {
                            navigation.navigate('Course', {course_id: data.lesson.course_id})
                        }}>
                            <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white"/>
                        </TouchableOpacity>
                    </View>

                    <ScrollView style={{flex: 1}}>

                        <View style={styles.boxvideo}>
                            {data.lesson.video ?
                                <>
                                    {isPreloading ?
                                        <Image style={styles.image}
                                               source={{uri: `${Config.dl}/${data.lesson.image}`}}/>
                                        :
                                        <Video
                                            ref={videoRef}
                                            style={styles.video}
                                            source={{uri: `${Config.dl}/${data.lesson.video}`}}
                                            useNativeControls
                                            resizeMode="contain"
                                            onReadyForDisplay={() => {
                                                setIsPreloading(false);
                                            }}
                                            onPlaybackStatusUpdate={(status) => {
                                                setIsPlaying(status.isPlaying);
                                                if (subtitles.length > 0) {
                                                    const currentTime = status.positionMillis / 1000;
                                                    const index = subtitles.findIndex(
                                                        sub => currentTime >= sub.start && currentTime < sub.end
                                                    );

                                                    if (index !== lastIndexRef.current) {
                                                        lastIndexRef.current = index;

                                                        if (index !== -1) {
                                                            // حالت عادی: زیرنویس فعلی پیدا شد
                                                            setCurrentSubtitle(subtitles[index].text);
                                                            setCurrentStartTime(subtitles[index].start);

                                                            const prev = subtitles.slice(Math.max(0, index - CONTEXT_COUNT), index);
                                                            setPrevSubtitles(prev);

                                                            const next = subtitles.slice(index + 1, index + 1 + CONTEXT_COUNT);
                                                            setNextSubtitles(next);
                                                        } else {
                                                            // حالت گپ: بین دو زیرنویس هستیم
                                                            // آخرین زیرنویسی که گذشت را پیدا کن تا صفحه خالی نماند
                                                            let lastPassedIndex = -1;
                                                            for (let i = 0; i < subtitles.length; i++) {
                                                                if (subtitles[i].end <= currentTime) {
                                                                    lastPassedIndex = i;
                                                                } else {
                                                                    break;
                                                                }
                                                            }

                                                            if (lastPassedIndex !== -1) {
                                                                // زیرنویس قبلی را نگه دار تا صفحه خالی نشود
                                                                setCurrentSubtitle(subtitles[lastPassedIndex].text);
                                                                setCurrentStartTime(subtitles[lastPassedIndex].start);

                                                                const prev = subtitles.slice(
                                                                    Math.max(0, lastPassedIndex - CONTEXT_COUNT),
                                                                    lastPassedIndex
                                                                );
                                                                setPrevSubtitles(prev);

                                                                const next = subtitles.slice(
                                                                    lastPassedIndex + 1,
                                                                    lastPassedIndex + 1 + CONTEXT_COUNT
                                                                );
                                                                setNextSubtitles(next);
                                                            }
                                                            // اگر هنوز به اولین زیرنویس نرسیده‌یم، stateها را پاک نکن
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    }
                                </>
                                :
                                <Image style={styles.image} source={{uri: `${Config.dl}/${data.lesson.image}`}}/>
                            }
                        </View>
                        <View style={styles.content}>
                            <View style={{flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                <View style={{flexDirection : "row", alignItems : "center"}}>
                                    <SwitchToggle
                                        defaultValue={showfarsi}
                                        onToggle={(value) => setShowFarsi(value)}
                                    />
                                    <Text style={styles.refer}>
                                        نمایش زیر نویس فارسی
                                    </Text>
                                </View>

                                <View style={{flexDirection : "row", alignItems : "center"}}>
                                    <SwitchToggle
                                        defaultValue={showEnglish}
                                        mainColor={Config.maincolor}
                                        onToggle={(value) => setShowEnglish(value)}
                                    />
                                    <Text style={styles.refer}>
                                        نمایش زیر نویس انگلیسی
                                    </Text>
                                </View>
                            </View>

                            {data.lesson.subtitle &&
                                <View style={[styles.subtitlesBlock, { justifyContent: 'center' }]}>

                                    {currentSubtitle ? (
                                        <TwoLineText
                                            showfarsi={showfarsi}
                                            showenglish={showEnglish}
                                            lesson_id={route.params.lesson_id}
                                            text={currentSubtitle}
                                            video={videoRef}
                                        />
                                    ) : null}

                                    {/* نمایش زیرنویس‌های قبلی */}
                                    {prevSubtitles.map((subItem, index) => (
                                        <TwoLineText2
                                            key={`prev-${index}`}
                                            showfarsi={showfarsi}
                                            showenglish={showEnglish}
                                            text={subItem.text}
                                            seekTo={subItem.start}
                                            video={videoRef}
                                            play={0}
                                        />
                                    ))}

                                    {/* نمایش زیرنویس فعلی در وسط */}
                                    {currentSubtitle ? (
                                        <TwoLineText2
                                            showfarsi={showfarsi}
                                            showenglish={showEnglish}
                                            lesson_id={route.params.lesson_id}
                                            text={currentSubtitle}
                                            video={videoRef}
                                            seekTo={currentStartTime}
                                            play={1}
                                        />
                                    ) : null}

                                    {/* نمایش زیرنویس‌های بعدی */}
                                    {nextSubtitles.map((subItem, index) => (
                                        <TwoLineText2
                                            key={`next-${index}`}
                                            showfarsi={showfarsi}
                                            showenglish={showEnglish}
                                            text={subItem.text}
                                            seekTo={subItem.start}
                                            video={videoRef}
                                            play={0}
                                        />
                                    ))}
                                </View>
                            }

                        </View>
                    </ScrollView>

                    <View style={styles.footer}>
                        <TouchableOpacity onPress={()=> {
                            setShowModal(true);
                            videoRef.current.pauseAsync();
                        }} style={styles.button}>
                            <Text style={styles.buttonText}>  ادامه </Text>
                        </TouchableOpacity>
                    </View>

                    <Modal
                        animationType="fade"
                        transparent={false}
                        visible={showModal}
                        style={{
                            flexGrow : 1
                        }}
                        onRequestClose={() => {
                            setShowModal(false);
                        }}>
                        <View style={{paddingVertical : RFValue(20) ,paddingHorizontal : RFValue(20) , flexGrow : 1}}>
                            <View style={{flexGrow : 1}}>
                                <FontAwesome onPress={()=>setShowModal(false)} style={{position : 'absolute' , left : 10, zIndex : 10}} name="close" size={28} color="red" />
                                <ScrollView showsVerticalScrollIndicator={false} style={{width: '100%',paddingVertical : RFValue(25)}}>
                                    <RenderHtml
                                        style={{width: '100%'}}
                                        contentWidth={width}
                                        source={{html: data.lesson.description}}
                                        systemFonts={['yk']}
                                        tagsStyles={{div: {fontFamily: 'yk'}}}
                                    />

                                    {data.keywords.length !== 0 &&
                                        <View style={styles.vocab}>
                                            <Text style={styles.vocabtitle}>لغات جدیدی که از این درس یاد گرفتی!</Text>
                                            <View style={styles.vocabitems}>
                                                {data.keywords.map((item, index) =>
                                                    <Text key={index} style={styles.vocabtxt}>
                                                        <Text style={styles.labelvocab}>{item.name}:</Text>
                                                        {item.val}
                                                    </Text>
                                                )}
                                            </View>
                                        </View>
                                    }

                                    {data.lesson.pdf &&
                                        <View style={styles.pdf}>
                                            <View style={styles.pdfname}>
                                                <AntDesign name="pdffile1" size={RFValue(27)} color="#0D1134"/>
                                                <Text style={styles.pdftxt}> {data.lesson.title}</Text>
                                            </View>
                                            <TouchableOpacity
                                                onPress={() => Linking.openURL(`${Config.base}/${data.lesson.pdf}`)}
                                                style={styles.dl}>
                                                <Text style={styles.dltxt}>دانلود</Text>
                                                <Entypo name="download" size={RFValue(27)} color={Config.secondcolor}/>
                                            </TouchableOpacity>
                                        </View>
                                    }
                                    {data.lesson.has_exam &&
                                        <>
                                            <Text style={[styles.buttonText,{marginVertical : 20}]}>
                                                انتخاب دسته آزمون
                                            </Text>
                                            <View style={{marginVertical : RFValue(5)}}></View>
                                        {data.category.map((item, index) =>
                                           <>
                                               {item.id == category_id ?
                                                   <TouchableOpacity  key={index}  style={[styles.button2, {marginTop : RFValue(10)}]}>
                                                       <Feather name="check-circle" size={24} color="white"style={{marginLeft: RFValue(5)}} />
                                                       <Text style={styles.buttonText2}>

                                                           {item.name}
                                                       </Text>
                                                   </TouchableOpacity>
                                                   :
                                                   <TouchableOpacity onPress={()=>setCategory_id(item.id)} key={index}  style={[styles.button, {marginTop : RFValue(10)}]}>
                                                       <Text style={styles.buttonText}>  {item.name} </Text>
                                                   </TouchableOpacity>
                                               }

                                           </>
                                        )}
                                        </>
                                    }

                                </ScrollView>
                            </View>
                            {data.lesson.has_exam ?
                                <TouchableOpacity onPress={() => {
                                    setShowModal(false);
                                    navigation.navigate('Exam', {lesson_id: data.lesson.id , category_id : category_id});
                                }} style={styles.button}>
                                    <Text style={styles.buttonText}> بریم برا تمرین </Text>
                                </TouchableOpacity>
                                :
                                <>
                                    {disable ?
                                        <TouchableOpacity disabled={disable} style={styles.button}>
                                            <Text style={styles.buttonText}> درس بعدی ... </Text>
                                        </TouchableOpacity>
                                        :
                                        <TouchableOpacity onPress={nextlesson} style={styles.button}>
                                            <Text style={styles.buttonText}> درس بعدی </Text>
                                        </TouchableOpacity>
                                    }
                                </>
                            }

                        </View>
                    </Modal>

                </>
                :
                <Loading/>
            }



        </View>
    );
}

const styles = StyleSheet.create({
    labelvocab: {fontFamily: 'ykb', fontSize: RFValue(13), color: '#0D1134', paddingLeft: RFValue(10)},
    vocabtxt: {
        fontFamily: 'yk',
        maxWidth: '60%',
        fontSize: RFValue(12),
        color: '#0D1134',
        direction: 'ltr',
        width: (Dimensions.get("window").width / 2) - RFValue(25),
        paddingVertical: RFValue(8),
        textAlign: 'left'
    },
    vocabitems: {
        direction: 'ltr',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        paddingLeft: RFValue(7)
    },
    vocabtitle: {
        fontFamily: 'ykb',
        fontSize: RFValue(14),
        color: '#0D1134',
        textAlign: 'center',
        marginBottom: RFValue(8)
    },
    vocab: {
        direction: 'ltr',
        backgroundColor: '#F4F6FF',
        marginBottom: RFValue(30),
        paddingVertical: RFValue(30),
        borderRadius: RFValue(10),
        marginTop : RFValue(20),
    },
    dltxt: {fontFamily: 'ykb', fontSize: RFValue(16), color: Config.secondcolor, marginLeft: RFValue(6)},
    pdftxt: {fontFamily: 'ykb', fontSize: RFValue(14), color: '#0D1134', marginRight: RFValue(6)},
    pdfname: {flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'},
    dl: {flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'},
    pdf: {
        padding: RFValue(10),
        borderRadius: RFValue(10),
        borderColor: '##E7E9F2',
        borderWidth: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    footer: {
        paddingVertical: RFValue(10),
        paddingHorizontal: RFValue(20),
        justifyContent: 'center',
        alignItems: 'center'
    },
    buttonText: {fontFamily: 'ykb', fontSize: RFValue(16), color: Config.maincolor},
    button: {
        backgroundColor: Config.secondcolor,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        borderTopRightRadius: RFValue(20),
        borderBottomRightRadius: RFValue(20),
        borderTopLeftRadius: RFValue(20),
        borderBottomLeftRadius: RFValue(20),
        height: RFValue(45),
        flexDirection: 'row',
        paddingHorizontal: RFValue(25)
    },


    buttonText2: {
        fontFamily: 'ykb',
        fontSize: RFValue(16),
        color: 'white',
        direction : 'rtl',
        justifyContent: 'center',
    },
    button2: {
        backgroundColor: Config.maincolor,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',

        borderTopRightRadius: RFValue(20),
        borderBottomRightRadius: RFValue(20),
        borderTopLeftRadius: RFValue(20),
        borderBottomLeftRadius: RFValue(20),
        height: RFValue(45),
        flexDirection: 'row',
        paddingHorizontal: RFValue(25)
    },


    video: {
        width: '100%',
        height: RFValue(200),
        borderRadius: RFValue(5),
        backgroundColor: '#171b1c',
    },
    image: {
        width: '100%',
        height: RFValue(165),
        borderRadius: RFValue(15),
    },
    des: {fontFamily: 'yk', fontSize: RFValue(16), color: '#0D1134', textAlign: 'justify'},
    h1: {
        fontFamily: 'ykb',
        fontSize: RFValue(16),
        color: '#fff',
        marginVertical: RFValue(10),
    },
    h2: {
        fontFamily: 'ykb',
        fontSize: RFValue(12),
        color: 'white',
        marginVertical: RFValue(10)
    },
    price: {fontFamily: 'ykb', fontSize: RFValue(16), color: '#0D1134', marginVertical: RFValue(10)},

    subtitlesBlock: {
        marginTop: RFValue(10),
        alignItems: 'center',
        paddingHorizontal: RFValue(10),
        minHeight: RFValue(150) // حداقل ارتفاع برای جلوگیری از پرش UI
    },
    subtitlePrev: {
        fontFamily: 'yk',
        fontSize: RFValue(14),
        color: '#9ca8ab',
        textAlign: 'center',
        direction: 'ltr',
        paddingVertical: RFValue(4),
    },
    subtitleCurrent: {
        fontFamily: 'ykb',
        fontSize: RFValue(18),
        color: '#000',
        textAlign: 'center',
        marginVertical: RFValue(4),
        direction: 'ltr',
    },
    subtitleNext: {
        fontFamily: 'yk',
        fontSize: RFValue(14),
        color: '#9ca8ab',
        textAlign: 'center',
        direction: 'ltr',
    },

    content: { flex: 1, paddingHorizontal: RFValue(20), justifyContent: "center", paddingVertical: RFValue(0)},
    container: {
        flex: 1,
        backgroundColor: '#171b1c'
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),
        shadowColor: "#000000",
        shadowOffset: {width: 0, height: 50},
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },
    title: {fontSize: RFValue(14), fontFamily: 'ykb', color: '#FFF', paddingVertical: RFValue(5)},
    refer :{
        fontFamily: "yk",
        fontSize: RFValue(10),
        paddingHorizontal : RFValue(10),
        paddingVertical : RFValue(10),
        color: 'white',
    },
    boxvideo : {
        marginBottom: RFValue(5),
    }
});


function TwoLineText({ text ,showfarsi = true , showenglish = true ,video ,lesson_id}) {
    let firstLine = "";
    let secondLine = "";

    if (text.includes("\n")) {
        const lines = text.split("\n");
        firstLine = lines[0];
        secondLine = lines.slice(1).join("\n");
    } else {
        firstLine = text;
    }

    return (
        <View style={{
            alignItems: "center",
            paddingVertical: RFValue(15),
            paddingHorizontal: 10,
        }}>
            {showenglish &&
                <WordSplitter video={video} text={firstLine} lesson_id={lesson_id} />
            }
            {showfarsi &&
                <Text style={{
                    color: Config.secondcolor,
                    fontSize: 16,
                    fontFamily: 'ykb',

                    marginTop: RFValue(2),
                }}>{secondLine}</Text>
            }
        </View>
    );
}

function TwoLineText2({ text ,showfarsi = true , showenglish = true, video, seekTo , play }) {
    let firstLine = "";
    let secondLine = "";

    if (text && text.includes("\n")) {
        const lines = text.split("\n");
        firstLine = lines[0];
        secondLine = lines.slice(1).join("\n");
    } else {
        firstLine = text || "";
    }

    const handleSeek = async () => {
        if (video && video.current && seekTo !== undefined) {
            try {
                // انتقال ویدیو به ثانیه مورد نظر (setPositionAsync میلی ثانیه میگیرد)
                await video.current.setPositionAsync(Math.max(0, seekTo * 1000));
                // ویدیو را از حالت پاز درمیاریم تا پخش شود
                await video.current.playAsync();
            } catch (e) {
                console.log("Error seeking video", e);
            }
        }
    };

    return (
        <TouchableOpacity
            activeOpacity={0.7}
            onPress={handleSeek}
            style={{
                alignItems: "center",
                paddingVertical: RFValue(4),
                paddingHorizontal: 5,

            }}
        >
            {showenglish &&
                <Text style={styles.subtitlePrev}>
                    {play &&
                        `▶`
                    }
                    {firstLine}
                </Text>
            }
            {/*{(showfarsi) &&*/}
            {/*    <Text style={styles.subtitlePrev}>{secondLine}</Text>*/}
            {/*}*/}
        </TouchableOpacity>
    );
}

export default Lesson;